import React from 'react'
import PropTypes from 'prop-types'
import loadable from 'react-loadable'

const Loading = ({ pastDelay }) =>
  pastDelay ? (
    <div style={{ margin: 'auto' }} className="vx_spinner-small" />
  ) : null

Loading.propTypes = {
  pastDelay: PropTypes.bool.isRequired,
}

/**
 * Do not show anything while loading
 * Useful when the loading component does not block user interaction
 */
const SilentLoading = () => null

export default (loader, showLoading = true) =>
  loadable({
    loader,
    loading: showLoading ? Loading : SilentLoading,
    delay: 900,
  })
